import type { Rng } from './rng';

export type WeatherKind = 'none' | 'thunderstorm' | 'sprinkler';

// Per Puppies2026.md: after level 3, ~1:40 chance per turn, gets more
// frequent every 3 levels. We split: ~1/3 thunderstorm, ~2/3 sprinkler.
export function shouldTriggerWeather(level: number, rng: Rng): WeatherKind {
  if (level < 4) return 'none';
  const levelStep = Math.floor((level - 4) / 3);
  const baseDenominator = Math.max(40 - levelStep * 5, 10);
  if (rng() * baseDenominator >= 1) return 'none';
  return rng() < 0.33 ? 'thunderstorm' : 'sprinkler';
}
